export default __webpack_public_path__ + "static/media/DownChevron.b9ff0d37.svg";